import { useSelector } from "react-redux";
import LogoutButton from "../pages/LogoutButton";

const Header = () => {
  const user = useSelector((state) => state?.user);

  const username = user.user?.username;

  return (
    <header className={"d-flex justify-content-between align-items-center"}>
      <div style={{ fontWeight: 500 }}>{username}</div>
      <div className="d-flex align-items-center">
        <LogoutButton />
      </div>
    </header>
  );
};

export default Header;
